import { createContext, useContext, Dispatch } from 'react';

import { PhoneActionType, PhoneActions, PhoneStateType } from '../types';

import { initialState } from './reducer';

type StoreType = {
  state: PhoneStateType;
  dispatch: Dispatch<PhoneActionType>;
  actions: PhoneActions;
};

export const PhoneListContext = createContext<StoreType>({
  state: initialState,
  dispatch: () => {},
  actions: {
    setPhones: () => {},
    setLoadingPhones: () => {},
    searchByNumber: () => {},
    searchByAccount: () => {},
    searchByCampaign: () => {},
    setAccounts: () => {},
    setCampaigns: () => {},
    setSelectedPhones: () => {},
    paginate: () => {},
    assignToCampaign: () => Promise.resolve(),
    assignToAccount: () => Promise.resolve(),
  },
});

export const usePhoneListContext = (): StoreType => useContext(PhoneListContext);
